import * as React from "react";
import Box from "@mui/material/Box";
import Slider from "@mui/material/Slider";

export default function ValueRange({
  title,
  ...props
}) {
  return (
    <>
      <p
        style={{
          fontSize: "12px",
          marginBottom: "2px",
          color: "#2C4992",
          weight: "400",
          font: "roboto",
          paddingTop: "5px",
        }}
      >
        {title}
      </p>
      <Box
        sx={{
          borderRadius: 1,
          borderWidth: 1,
          paddingRight: 2,
          paddingLeft: 2,
          paddingTop: 3.5,
          height: 57,
        }}
        border={4}
        borderColor="#001EB3"
      >
        <Slider
          color={"blue"}
          valueLabelDisplay="on"
          sx={{".MuiSlider-valueLabel":{fontSize:"12px"}}}
          {...props}
        />
      </Box>
    </>
  );
}
